/**
 * Creates a javascript Date object from a unix timestamp
 * @param value the unix timestamp to parse
 */
export const parseDateFromUnixTimestamp = (value: number): Date => {
  return new Date(value * 1000);
};

/**
 * Converts a javascript Date object into a unix timestamp
 * @param value
 */
export const convertDateToUnixTimestamp = (value: Date): number => {
  return Math.floor(value.getTime() / 1000);
};
